var React = require('react');

function Plus (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"M17.594 17.203v9.219c0 2-3 2-3 0v-9.22H5.376c-2 0-2-3 0-3h9.218v-8.84c0-2 3-2 3 0v8.84h8.842c2 0 2 3 0 3h-8.842z"}));
}

Plus.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32"};

module.exports = Plus;

Plus.default = Plus;
